import { getStyles } from '@kubit/web-ui-components/utils/getStyles';
import styled from 'styled-components';
export const TextCountContainerStyled = styled.div `
  ${({ styles }) => getStyles(styles?.wrapper)};
  // external prop to overwrite the margin-top
  ${({ marginTop }) => marginTop && `margin-top: ${marginTop};`}
`;
//# sourceMappingURL=textCount.styled.js.map